import { ApplicationClaim } from "./applicationClaim";

export class AccountApplicationClaim {
    accountOrganisationId: string;
    applicationId: string;
    applicationName: string;
    userId: string;
    accountId: string;
    organisationName: string;
    statusCode: string;
    applicationClaims: ApplicationClaim[];
}


// WEBPACK FOOTER //
// ./src/app/models/accountApplicationClaim.ts